import deliverabilityAlertsMapService from "../api/server/deliverabilityAlertsMapService";
export const DELIVERABILITY_ALERTS_MAP_NAMESPACE =
  "deliverabilityAlertsMapModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/deliverabilityAlertsMapService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(deliverabilityAlertsMapService)
};

const state = {
  alertsData: {},
  alertTypes: [],
  loadingAlerts: false,
  loadingFiles: false,
  loadingHurricaneData: false,
  overlayFiles: [],
  hurricaneData: {}
};

const actions = {
  async loadAlertTypes(context) {
    var api = await services.api;
    return api.loadAlertTypes().then(function(value) {
      context.commit("SET_ALERT_TYPES", value);
    });
  },
  async loadMapData(context, disableCache) {
    context.commit("SET_LOADING_ALERTS", true);
    var api = await services.api;
    return api
      .loadMapData(disableCache)
      .then(function(value) {
        if (value.payload) context.commit("SET_ALERTS_DATA", value.payload);
        context.commit("SET_LOADING_ALERTS", false);
      })
      .catch(() => {
        context.commit("SET_ALERTS_DATA", {});
        context.commit("SET_LOADING_ALERTS", false);
      });
  },
  async loadMapOverlayFiles(context) {
    context.commit("SET_LOADING_FILES", true);
    var api = await services.api;
    return api.loadMapOverlayFiles().then(function(value) {
      context.commit("SET_LOADING_FILES", false);
      var data = value.payload.fileList;
      context.commit("SET_OVERLAY_FILES", data);
    });
  },
  async loadOverlayFile(context, fileName) {
    var api = await services.api;
    return api.loadOverlayFile(fileName).then(function(value) {
      return value;
    });
  },
  async loadHurricaneStormData(context, atcfId) {
    var api = await services.api;
    return api.getHurricaneStormData(atcfId).then(function(value) {
      return value.payload.data;
    });
  },
  async loadHurricaneStormTrackData(context, atcfId) {
    var api = await services.api;
    return api.getHurricaneStormTrackData(atcfId).then(function(value) {
      return value.payload.data;
    });
  },
  async loadHurricaneStormList(context) {
    context.state.loadingHurricaneData = true;
    var api = await services.api;
    return api.getHurricaneStormList().then(function(value) {
      context.state.loadingHurricaneData = false;
      context.commit("SET_HURRICANE_DATA", value.payload.forecastSummary);
    });
  }
};

const mutations = {
  SET_ALERT_TYPES(storeState, data) {
    storeState.alertTypes = data.sort(function(a, b) {
      return a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : b.Name.toLowerCase() > a.Name.toLowerCase()
        ? -1
        : 0;
    });
  },
  SET_ALERTS_DATA(storeState, data) {
    storeState.alertsData = data;
  },
  SET_LOADING_ALERTS(storeState, data) {
    storeState.loadingAlerts = data;
  },
  SET_LOADING_FILES(storeState, data) {
    storeState.loadingFiles = data;
  },
  SET_OVERLAY_FILES(storeState, data) {
    storeState.overlayFiles = data;
  },
  SET_HURRICANE_DATA(storeState, data) {
    storeState.hurricaneData = data;
  }
};

const getters = {
  alertsData: storeState => storeState.alertsData,
  alertTypes: storeState => storeState.alertTypes,
  loadingAlerts: storeState => storeState.loadingAlerts,
  loadingFiles: storeState => storeState.loadingFiles,
  loadingHurricaneData: storeState => storeState.loadingHurricaneData,
  overlayFiles: storeState => storeState.overlayFiles,
  hurricaneData: storeState => storeState.hurricaneData
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
